<section class="footer-section">
  <div class="container-large">
    <div class="footer-grid">
      <div id="w-node-_1210ba5a-661e-5fec-8720-a1fe347b676f-d1959954" class="footer-column">
        <div class="text-color-muted">Case Studies</div>
        <a href="/glp1" class="footer-link">GLP-1</a>
        <a href="/adc-oncology" class="footer-link">ADC Oncology</a>
        <a href="/studies/sglt-2" class="footer-link">SGLT-2</a>
        <a href="/studies/anti-vegf" class="footer-link">Anti-VEGF</a>
        <a href="/studies/anti-il-23" class="footer-link">Anti-IL-23</a>
      </div>
      <div class="footer-column">
        <div class="text-color-muted">About</div>
        <a href="/legal-page" class="footer-link">Legal </a>
        <a href="/news" class="footer-link">News Room</a>
        <a href="/research" class="footer-link">Research</a>
        <a href="/careers" class="footer-link">Careers</a>
        <a href="/contact" class="footer-link">Contact Us</a>
      </div>
      <div class="footer-column">
        <div class="text-color-muted">Social</div>
        <a
          href="https://www.linkedin.com/company/imx-data/"
          target="_blank"
          rel="noopener noreferrer"
          class="footer-link">LinkedIn</a
        >
      </div>
    </div>
    <div class="spacer-96"></div>
    <div class="divider-line"></div>
    <div class="spacer-40"></div>
    <div class="footer-bottom">
      <div class="footer-link text-color-muted">© {new Date().getFullYear()} IMX Data, LLC</div>
    </div>
  </div>
</section>
